import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]
  static values = {
    onConnect: { type: Boolean, default: false },
    select: { type: Boolean, default: false }
  }

  connect() {
    if (this.onConnectValue) {
      this.focus()
    }
  }

  get focusable() {
    return this.hasFieldTarget ? this.fieldTarget : this.element
  }

  focus() {
    const el = this.focusable
    el.focus()
    if (this.selectValue && typeof el.select === "function") {
      el.select()
    }
  }
}
